import { render, staticRenderFns } from "./AcquitAlertFormDialogComponent.vue?vue&type=template&id=22871c18&"
import script from "./AcquitAlertFormDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AcquitAlertFormDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports